var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.6V1.2L10.875 5.6M1.5 0C0.6675 0 0 0.712 0 1.6V14.4C0 14.8243 0.158035 15.2313 0.43934 15.5314C0.720644 15.8314 1.10218 16 1.5 16H10.5C10.8978 16 11.2794 15.8314 11.5607 15.5314C11.842 15.2313 12 14.8243 12 14.4V4.8L7.5 0H1.5Z",
    fill: "#A1B3C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.fd574f6c7d1be8c8e5ad8fd321fad71d.svg";
export { ForwardRef as ReactComponent };